<ng-content select="rs-card-header"> </ng-content>
<!-- p-2 overflow-auto -->
<div class="d-flex flex-column flex-fill overflow-hidden">
  <ng-content> </ng-content>
</div>
